import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IGlobalFile } from '@leedpulse-monorepo/interfaces';
import { TFileOwnerType } from '@leedpulse-monorepo/types';

async function getAllFiles(
  pageSize: number,
  page: number,
  auth: Authentication | null,
  ownerType: TFileOwnerType | 'all' = 'all'
): Promise<{
  items: IGlobalFile[];
  totalCount: number;
}> {
  try {
    if (!auth) throw new GetAllFilesFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const query = new URLSearchParams({ pageSize: String(pageSize), page: String(page), type: ownerType });

    const response = await HttpClient.get(
      `/backoffice/files?${query.toString()}`,
      auth.token
    );

    if (!response.success) throw new GetAllFilesFailure(response.message, response.code);
    return response.data;
  } catch (e) {
    if (e instanceof GetAllFilesFailure) throw e;
    throw new GetAllFilesFailure();
  }
}

export class GetAllFilesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getAllFiles;
